<template>
  <el-dialog
    :title="$t('mfa.title')"
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    width="500px"
    @close="handleClose"
  >
    <div style="margin-bottom: 20px">
    {{ $t('mfa.enter_code') }}
   </div>
    <el-form :model="formData" ref="form" :rules="rules">
      <el-form-item :label="$t('mfa.code')" prop="mfa_code">
        <el-input
          v-model="formData.mfa_code"
          :placeholder="$t('mfa.placeholder')"
          maxlength="6"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('components.cancel') }}</el-button>
      <el-button type="primary" @click="handleConfirm">{{ $t('components.confirm') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'MfaVerifyDialog',
  props: {
    // 添加visible属性用于控制显示/隐藏
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: {
        mfa_code: ''
      }
    }
  },
  computed: {
    // 使用计算属性处理 visible 的双向绑定
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },
    rules() {
      return {
        mfa_code: [
          { required: true, message: this.$t('mfa.required'), trigger: 'blur' },
          { len: 6, message: this.$t('mfa.length'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    handleClose() {
      this.formData.mfa_code = ''
      this.$refs.form?.resetFields()
      this.$emit('close')
    },
    handleConfirm() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.$emit('confirm', this.formData.mfa_code)
        }
      })
    }
  }
}
</script>
